package music.limasoul.client.shared.network

import io.ktor.http.HttpStatusCode
import music.limasoul.shared.network.domain.model.AppException
import music.limasoul.shared.network.domain.model.ErrorWrapper

interface ErrorMapper {

    fun map(error: ErrorWrapper.Error): Throwable?
}

internal class JammersErrorMapper : ErrorMapper {

    override fun map(error: ErrorWrapper.Error): Throwable =
        AppException(
            status = HttpStatusCode.fromValue(error.status),
            message = error.message,
        )
}